import React from 'react';
import PropTypes from 'prop-types';

export default class NewField extends React.Component<any> {

    static propTypes = {
        selected: PropTypes.bool,

        onSelectSection: PropTypes.func.isRequired
    }

    onSelectSection = () => {
        this.props.onSelectSection('new-field');
    }

    render() {
        return (
            <div key="new-field" className="add blue-small" onClick={this.onSelectSection}>
                <div className="i5-plus icon"></div>
                <div className="name">New field</div>
            </div>
        )
    }
}
